import { GqlClient } from "@/services/graph-ql/configs";
import { getCookie } from "../generic.methods";

/** @name: @getServerSideData
 *  @params: options => this could be array of object or object of query information
 *                      which include query to be fetched, query name and params
 *                      required in query
 *  @description: check options type and operate accordingly
 */
const getServerSideData = async (payload, isPublic = false) => {
  const { request, context } = payload;
  try {
    if (Array.isArray(request)) {
      const combineData = await iterateQueries(request, context, isPublic);
      return combineData;
    } else if (!Array.isArray(request) && typeof request === "object") {
      const data = await getFromGQL(request, context);
      return data;
    }
  } catch (error) {
    console.error(
      "The query parameter should be an array of object or a single object",
      error
    );
    return error;
  }
};
/** @name: @iterateQueries
 *  @params: options => this could be array of objects, object are queries
 *  @description: iterate over the options and fetch from gql
 */
const iterateQueries = async (options, context, isPublic = false) => {
  const promises = options.map((option) => {
    return getFromGQL(option, context, isPublic)
      .then((data) => ({ key: option?.key, data }))
      .catch((error) => ({
        key: option?.key,
        error,
        data: null,
      }));
  });

  const results = await Promise.allSettled(promises);

  const combineData = {};
  results.forEach((result) => {
    if (result.status === "fulfilled") {
      const { key, data } = result.value;
      combineData[key] = data;
    } else {
      // If the promise itself rejected
      combineData[result.value?.key || "unknown"] = null;
    }
  });
  return combineData;
};
/** @name: @getFromGQL
 *  @params: query: gql query,key: nested object key of the fetched data, variable: query parameters
 *  @description: fetch data from gql
 */
const getFromGQL = async (options, context, isPublic = false) => {
  const isPublicPage = typeof window !== 'undefined' && (
    window.location.pathname.includes("book-an-appointment") ||
    window.location.pathname.includes("reschedule-an-appointment") ||
    window.location.pathname.includes("cancel-an-appointment")
  );

  if (isPublicPage && !options?.bypassPublicPageCheck) {
    return [];
  }

  const {
    query,
    key,
    subKey = "",
    params,
    alternateKey = "",
    context: customContext,
  } = options;
  const cookies = context?.req?.cookies;

  const urlParams = new URLSearchParams(window.location.search);
  // Get a specific parameter
  const companyKey = urlParams.get("companykey");
  const ref = urlParams.get("ref");
  let headers = {};

  if (isPublic) {
    headers = {
      ...(ref ? { maskedcompanykey: ref } : { companyKey: companyKey || "" }),
    };
  } else {
    headers = {
      authorization: cookies?.Auth,
      companyKey: cookies?.companyKey || companyKey,
      ...(params?.ApexMainAuthToken
        ? {
            ApexMainAuthToken:
              getCookie("Auth"),
          }
        : {}),
    };
  }

  try {
    const response = await GqlClient.query({
      query,
      variables: params,
      fetchPolicy: "no-cache",
      context: {
        clientName: customContext?.clientName || "",
        headers: { ...headers },
      },
    });
    return key
      ? subKey
        ? response?.data?.[key][subKey]
        : response?.data?.[key] || response?.data?.[alternateKey]
      : response?.data;
  } catch (error) {
    console.error("GQL Error::", error, key);
    return [];
  }
};

export default getServerSideData;
